import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import MarkdownRenderer from '../generic-ui/MarkdownRenderer';

const limitForField = (field, configuration) => {
    if (field === 'vision') {
        const n = Number(configuration?.visionViewMaxChars);
        return Number.isFinite(n) && n > 0 ? n : 600;
    }
    if (field === 'vision_short') {
        const n = Number(configuration?.visionShortViewMaxChars);
        return Number.isFinite(n) && n > 0 ? n : 600;
    }
    return null;
};

const ViewTextReactMarkdown = ({ values, field, moduleText, occupation = 6 }) => {
    const { t } = useTranslation();
    const configuration = useSelector((state) => state.configuration);

    const [expanded, setExpanded] = useState(false);
    const hasInformation = values[field] ? true : false;

    const ViewTextReactMarkdownRender = () => {
        if (!hasInformation) {
            return null;
        }

        const raw = String(values[field] || '');
        const maxChars = limitForField(field, configuration);
        const canToggle = Boolean(maxChars) && raw.length > maxChars;
        const text = canToggle && !expanded ? `${raw.slice(0, maxChars)}…` : raw;

        return (
            <div className={`col-md-${occupation} viewContentGroup`}>
            <label htmlFor={field} className="tit-view-view tit-content-view-view">
                {t(`${moduleText}.synthetic.${field}`)}
            </label>
            <MarkdownRenderer>
                {text}
            </MarkdownRenderer>
            {canToggle && (
                <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => setExpanded((current) => !current)}
                >
                    {expanded ? t('view.seeLess') : t('view.seeMore')}
                </button>
            )}
        </div>
        );
    }

    return (
        <ViewTextReactMarkdownRender />

    )

}

export default ViewTextReactMarkdown